import storage from './storage';
import { TEAM_KEYS, migratePrivateBucketsToTeam } from '../utils/teamCrmStore';

function key() {
  return TEAM_KEYS.tasks;
}

export const taskService = {
  getAll(_userId) {
    void _userId;
    migratePrivateBucketsToTeam();
    return storage.get(key(), []);
  },

  saveAll(_userId, tasks) {
    void _userId;
    storage.set(key(), tasks);
  },
};
